module.exports = "/post_box-c82bcaed2b131ae4292e92775ac578d1.svg";